import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';
import PromoCodeRow from './PromoCodeRow';
import * as appConstants from '../../App/app.constants';
import * as activityConstants from '../../Activity/activity.constants';

class PromoCodesTable extends React.PureComponent {
  static propTypes = {
    promoCodes: PropTypes.object.isRequired,
    changeActivityStatus: PropTypes.func.isRequired,
    extendPromoCodeStatus: PropTypes.func.isRequired,
    onDeletePromoCode: PropTypes.func.isRequired,
    goToPromoCode: PropTypes.func.isRequired,
    openPromoCodeInNewTab: PropTypes.func.isRequired,
    highlightedPromoCodeId: PropTypes.string,
    userAccessGroups: PropTypes.object,
    hasFullPermission: PropTypes.func,
  };

  goToPromoCode = (promoCodeId, promoCodeType) => {
    const isAccessGroupEnabled = this.props.hasFullPermission(appConstants.FEATURES_ACCESS_GROUPS)
    const userHasAccessGroups = this.props.userAccessGroups && this.props.userAccessGroups.size > 0;
    const selectedPromoCode = this.props.promoCodes.find(x => x.get(activityConstants.HUB_ID) === promoCodeId);

    if (isAccessGroupEnabled && userHasAccessGroups && !selectedPromoCode.get(activityConstants.ACCESS_GROUP_IDS)) {
      return;
    }

    this.props.goToPromoCode(promoCodeId, promoCodeType);
  }

  render() {
    const { formatMessage } = this.props.intl; // eslint-disable-line react/prop-types
    return (
      <Table className="ui single line fixed selectable very basic table">
        <Table.Header>
          <Table.Row className="promoCode-heading-row">
            <Table.HeaderCell
              className="list-column-name promoCode-type-column"
            >{formatMessage({ id: 'promoCodes-page.promoCode.type' })}</Table.HeaderCell>
            <Table.HeaderCell
              className="list-column-name promoCode-name-column"
            >{formatMessage({ id: 'promoCodes-page.promoCode.name' })}</Table.HeaderCell>
            <Table.HeaderCell
              className="list-column-name promoCode-benefits-column"
            >{formatMessage({ id: 'promoCodes-page.promoCode.benefits' })}</Table.HeaderCell>
            <Table.HeaderCell
              className="list-column-name promoCode-codes-column"
            >{formatMessage({ id: 'promoCodes-page.promoCode.codes' })}</Table.HeaderCell>
            <Table.HeaderCell
              className="list-column-name promoCode-status-column"
            >{formatMessage({ id: 'promoCodes-page.promoCode.status' })}</Table.HeaderCell>
            <Table.HeaderCell className="list-column-name promoCode-expand-arrow-column" />
            <Table.HeaderCell className="list-column-name promoCode-badge-column" />
            <Table.HeaderCell className="list-column-name promoCode-context-menu-column" />
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {this.props.promoCodes.map((promoCode, index) => (
            <PromoCodeRow
              changeActivityStatus={this.props.changeActivityStatus}
              onDeletePromoCode={this.props.onDeletePromoCode}
              goToPromoCode={this.goToPromoCode}
              highlightedActivityId={this.props.highlightedPromoCodeId}
              key={index.toString()}
              promoCode={promoCode}
              rowIndex={index}
              formatMessage={formatMessage}
              openPromoCodeInNewTab={this.props.openPromoCodeInNewTab}
              extendPromoCodeStatus={this.props.extendPromoCodeStatus}
              hasFullPermission={this.props.hasFullPermission}
              userAccessGroups={this.props.userAccessGroups}
            />
            ))}
        </Table.Body>
      </Table>
    );
  }
}

export default injectIntl(PromoCodesTable);
